import { useEffect, useState } from "react";
import API from "../services/api";

export default function ParentDashboard() {
  const [attendance, setAttendance] = useState([]);
  const [fees, setFees] = useState([]);
  const [results, setResults] = useState([]);

  const studentId = localStorage.getItem("studentId");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const attendanceRes = await API.get(`/attendance/${studentId}`);
      const feeRes = await API.get(`/payments/${studentId}`);
      const resultRes = await API.get(`/exams/${studentId}`);

      setAttendance(attendanceRes.data);
      setFees(feeRes.data);
      setResults(resultRes.data);

    } catch (err) {
      alert("Unable to load parent dashboard");
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">

      <h1 className="text-3xl font-bold mb-6">
        Parent Dashboard
      </h1>

      {/* Attendance */}
      <div className="bg-white shadow rounded p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">
          Attendance History
        </h2>

        <table className="w-full border">
          <thead>
            <tr>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {attendance.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Fee History */}
      <div className="bg-white shadow rounded p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">
          Fee History
        </h2>

        <table className="w-full border">
          <thead>
            <tr>
              <th>Term</th>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {fees.map((item) => (
              <tr key={item.id}>
                <td>{item.term}</td>
                <td>₹{item.amount_paid}</td>
                <td>{item.payment_date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Result History */}
      <div className="bg-white shadow rounded p-6">
        <h2 className="text-xl font-semibold mb-4">
          Exam Results
        </h2>

        <table className="w-full border">
          <thead>
            <tr>
              <th>Subject</th>
              <th>Marks</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            {results.map((item) => (
              <tr key={item.id}>
                <td>{item.subject}</td>
                <td>{item.marks_obtained}</td>
                <td>{item.total_marks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}